import React from "react"
import Edit from "../../../../assets/images/editinput.svg"
import {Select} from "@appkit4/react-components/select"
import PropTypes from 'prop-types';

function VendorInformation(props) {
    let { values, touched, errors, handleChange, handleBlur, getCriticality,role } = props

    function displayothercategoryfield() {
        if (values.category === "Others") {
            return (
                <div className="cv-input-field-container">
                    <input className="cv-input-field leftPadding"
                        type="text"
                        name="othercategory"
                    />
                    <img alt="edit" src={Edit} className="edit-input" />
                </div>
            )
        }
    }
    let disabledFields;
       if (role === "analyst" || role === "manager") {
        disabledFields = true
       }
      else {
        disabledFields = false //Can be changed according to future requirement.
      }
    return (

        <div>
            <div className="row m-0">
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                            Criticality
                        <span className="asterisk-required">*</span>
                        </label>
                        <Select
                            showSearchOnToggle={true}
                            dropdownRenderMode="portal"
                            searchable={true}
                            className="cv-input-field"
                            data={props.criticality}
                            labelKey="criticality"
                            valueKey="criticality_id"
                            onSelect={(e) => { handleChange("criticality")({ target: { value: e } }); getCriticality(e) }}
                            name="criticality"
                            value={values.criticality}
                            placeholder="Select Criticality"
                            disabled={disabledFields}
                        >
                        </Select>
                    </div>
                    {errors.criticality && touched.criticality && (
                        <div className="form-label error">{errors.criticality}</div>
                    )}
                </div>
                <div className="col-sm-6">
                    <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                        <label className="cv-input-label">
                     
                                Category
                      <span className="asterisk-required">*</span>
                        </label>
                        {values.category !== 6 ?
                            <Select
                                showSearchOnToggle={true}
                                dropdownRenderMode="portal"
                                searchable={true}
                                className="cv-input-field"
                                data={props.category}
                                labelKey="category"
                                valueKey="category_id"
                                onSelect={(e) => handleChange("category")({ target: { value: e } })}
                                value={values.category}
                                name="category"
                                placeholder="Select Category"
                                disabled={disabledFields}
                            >
                            </Select>
                            :
                            <>
                                <input className="cv-input-field leftPadding"
                                    type="text"
                                    value={values.others}
                                    onChange={handleChange("others")}
                                    name="others"
                                    placeholder="Add New Category"
                                    disabled={disabledFields}
                                ></input>
                                <span
                                    class="appkiticon icon-right-chevron-fill pointer"
                                    title="Select Existing Users"
                                    onClick={(e) => handleChange("category")({ target: { value: null } })}
                                >
                                </span></>
                        }
                    </div>
                    {errors.others && touched.others && (
                        <div className="form-label error">{errors.others}</div>
                    )}
                    {errors.category && touched.category && (
                        <div className="form-label error">{errors.category}</div>
                    )}
                </div>
            </div>
            <div className="row m-0">
                <div className="col-sm-6">
                    {displayothercategoryfield()}
                </div>
            </div>
        </div>
    )
}
VendorInformation.propTypes = {
    values: PropTypes.object,
    touched:PropTypes.object,
    errors:PropTypes.object,
    handleChange:PropTypes.func,
    handleBlur:PropTypes.func,
    role:PropTypes.string,
    criticality:PropTypes.array,
    }
export default VendorInformation